"use client";

import { useEffect } from "react";
import { enqueueSnackbar } from "notistack";
import {
  fetchPublicAuthConfig,
  getClockOffsetMs,
  subscribePublicAuthConfig,
} from "@/services/publicAuthConfigService";

const DEVICE_TIME_ALERT_THRESHOLD_MS = 5 * 60 * 1000;
let hasShownDeviceTimeAlert = false;

export default function AuthPublicConfigProvider() {
  useEffect(() => {
    let isMounted = true;

    const handleClockUpdate = () => {
      if (!isMounted) return;

      const diff = Math.abs(getClockOffsetMs());
      if (!hasShownDeviceTimeAlert && diff > DEVICE_TIME_ALERT_THRESHOLD_MS) {
        hasShownDeviceTimeAlert = true;
        enqueueSnackbar(
          "ساعت دستگاه شما بیش از ۵ دقیقه با سرور اختلاف دارد. لطفا ساعت دستگاه را تنظیم کنید.",
          {
            variant: "warning",
            autoHideDuration: 10000,
          }
        );
      }
    };

    fetchPublicAuthConfig().then(handleClockUpdate);
    const unsubscribe = subscribePublicAuthConfig(handleClockUpdate);

    return () => {
      isMounted = false;
      unsubscribe();
    };
  }, []);

  return null;
}
